import React from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoadingWrapper from 'components/Common/LoadingWrapper';
import LocalisedMessage from 'components/Common/LocalisedMessage';

const ValidationResultsStacked = ({ result, dirty, isGettingForm, previewOnlyMode }) => {
  function title() {
    if (result != null) {
      if (result.valid) {
        if (!dirty) {
          return <div>
            <span className="text-bold">Results</span>
            <span className="title-rejections-stacked valid">
              <span className="check fa-layers fa-2x">
                <FontAwesomeIcon icon="circle" />
                <span className="fa-sm"><FontAwesomeIcon icon="check" className="layered-button fa-sm" /></span>
              </span>
              { result.rejections != null && result.rejections.length } <LocalisedMessage id="validationResult.rejectionsHint" />
            </span>
          </div>;
        }
        return <div>
          <span className="text-bold">Results</span>
          <div className="title-rejections-stacked invalid">
            <span className="cross fa-layers fa-2x">
              <FontAwesomeIcon icon="circle" />
              <span className="fa-sm"><FontAwesomeIcon icon="times" className="layered-button fa-sm" /></span>
            </span>
            Press &apos;<LocalisedMessage id="validationResult.check.buttonText" />&apos;
          </div>
        </div>;
      }
      return <div>
        <span className="text-bold">Results</span>
        <span className="title-rejections-stacked invalid">
          <span className="cross fa-layers fa-2x">
            <FontAwesomeIcon icon="circle" />
            <span className="fa-sm"><FontAwesomeIcon icon="times" className="layered-button fa-sm" /></span>
          </span>
          { result.rejections != null && result.rejections.length } <LocalisedMessage id="validationResult.rejectionsHint" />{ `${ result.rejections.length !== 1 ? 's' : '' }` }
        </span>
      </div>;
    }
    return <div><span className="text-bold">Results</span></div>;
  }

  return <div id="validation-results-stacked" className="validation-results-stacked">
    <div className="wrapper-box">
      { isGettingForm && <div className="loading-container"><LoadingWrapper text="Please Wait..." /></div> }
      <div>{title()}
        <hr />
        <div>
          { !result && !isGettingForm && <React.Fragment>
            <p className="cp-primary mt-5"><strong>Please answer the questions and press &quot;Check&quot;.</strong></p>
            { previewOnlyMode && <React.Fragment>
              <p>Please complete these questions and then press the check button below to see if there are any problems.</p>
              <p>When any problems are resolved you will be able to download your answers in a tax form format for submitting to your tax advisor or relevant institution.</p>
            </React.Fragment> }
            { !previewOnlyMode && <React.Fragment>
              <p>Please complete these questions and then press the check button below to see if there are any problems.</p>
              <p>When any problems are resolved you will be able to sign and submit your answers.</p>
            </React.Fragment> }
          </React.Fragment> }
        </div>
        <div className="rejections-list">
          { result && result.rejections && result.rejections.length === 0 && dirty && <p>There have been changes made to the form, please press &apos;Check&apos; again to see if there are any more changes needed.</p>}
          { result && result.rejections && result.rejections.length > 0 && <React.Fragment>
            <h3 className="cs-error"><LocalisedMessage id="validationResult.rejectionsTitle" /></h3>
            <ul>
              { result.rejections.map(item => <li key={ item.code }>{item.codeDescription}</li>) }
            </ul>
          </React.Fragment> }
        </div>
        <div className="warnings-list">
          { result && result.warnings && result.warnings.filter(item => item.code.substring(0, 3) === 'WRN').length > 0 && <React.Fragment>
            <h3 className="cp-primary"><LocalisedMessage id="validationResult.warningsTitle" /></h3>
            <ul>
              { result.warnings.map(item => item.code.substring(0, 3) === 'WRN'
              && <li key={ item.code }>{item.codeDescription}</li>) }
            </ul>
          </React.Fragment> }
        </div>
        { result && result.warnings && result.warnings.filter(item => item.code.substring(0, 3) === 'REC').length > 0 && <div>
          <div className="recommendations-list">
            <h3 className="cp-main"><LocalisedMessage id="validationResult.recommendationsTitle" /></h3>
            <ul>
              { result.warnings.map(item => item.code.substring(0, 3) === 'REC'
              && <li key={ item.code }>{item.codeDescription}</li>) }
            </ul>
          </div>
        </div> }
      </div>
    </div>
  </div>;
};

ValidationResultsStacked.propTypes = {
  result: PropTypes.shape({
    valid: PropTypes.bool,
    formType: PropTypes.string,
    rejections: PropTypes.arrayOf(PropTypes.shape()),
    warnings: PropTypes.arrayOf(PropTypes.shape())
  }),
  dirty: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  isGettingForm: PropTypes.bool.isRequired,
  previewOnlyMode: PropTypes.bool.isRequired
};

ValidationResultsStacked.defaultProps = {
  result: null,
  dirty: false
};

export default injectIntl(ValidationResultsStacked);
